import Circle from 'react-circle';
import React, { useContext } from 'react';
import './styles.scss';
import {I18nContext} from "../../../providers/i18n";



const Candidate = ({ candidate, onClick = () => {} }) => {
  const { t } = useContext(I18nContext);

  return (
  <div className="candidate" onClick={() => onClick(candidate)}>
    <img alt={candidate.lastName} className="candidate-photo" src={candidate.photo} />
    <div className="candidate-description">
      <span className="candidate-name">
        {candidate.firstName} {candidate.lastName}
      </span>
      <span className="candidate-party">
        {candidate.yearOfBirth}, {candidate.partyName}
      </span>
    </div>
    <div className="percents">
      {candidate.hasData ? (
        <Circle
          progress={candidate.matching}
          textStyle={{
              fontSize: '5rem',
              fontFamily: 'OpenSans, Arial, sans-serif',
              fontWeight: 'bolder',
          }}
          size="60"
          lineWidth="15"
          bgColor="#eee"
          progressColor="rgb(13,43,79)"
          textColor="rgb(13,43,79)"
        />
      ):(<div className="no-result">{t('elections.candidatesMatch.noInfo')}</div>)
      }
    </div>
  </div>
)};

export default Candidate;
